import {
  computeFabricationDerivedFields,
  deliveryStatusFromOnTimeFlag,
  normalizeDeliveryStatus,
} from './fabricationJobCalculations';

/**
 * Maps pih-server fabrication dashboard API records to UI row shape.
 * @see pih-server/docs/FABRICATION_DASHBOARD_CURL.md
 */
export const normalizeFabricationJobFromApi = (row) => {
  if (!row || typeof row !== 'object') return row;

  const hrsVariancePct =
    row.hrsVariancePct != null
      ? Number(row.hrsVariancePct)
      : row.hrsVariancePercent != null
        ? Number(row.hrsVariancePercent) / 100
        : null;

  const rejectRatePct =
    row.rejectRatePct != null
      ? Number(row.rejectRatePct)
      : row.rejectRatePercent != null
        ? Number(row.rejectRatePercent) / 100
        : null;

  return {
    ...row,
    hrsVariancePct,
    rejectRatePct,
  };
};

/** UI list row: API fields + derived metrics for grid (prefer server values when present). */
export const mapFabricationJobForUi = (apiRow) => {
  const normalized = normalizeFabricationJobFromApi(apiRow);
  const computed = computeFabricationDerivedFields(normalized);

  const onTimeFlag =
    normalized.onTimeFlag != null && normalized.onTimeFlag !== ''
      ? Number(normalized.onTimeFlag)
      : computed.onTimeFlag;

  const deliveryStatus =
    deliveryStatusFromOnTimeFlag(onTimeFlag) ??
    normalizeDeliveryStatus(normalized.deliveryStatus) ??
    computed.deliveryStatus;

  return {
    ...normalized,
    hoursVariance:
      normalized.hoursVariance != null ? Number(normalized.hoursVariance) : computed.hoursVariance,
    hrsVariancePct: normalized.hrsVariancePct != null ? normalized.hrsVariancePct : computed.hrsVariancePct,
    onTimeFlag,
    deliveryStatus,
    deliveryDaysVariance:
      normalized.deliveryDaysVariance != null
        ? Number(normalized.deliveryDaysVariance)
        : computed.deliveryDaysVariance,
    rejectRatePct: normalized.rejectRatePct != null ? normalized.rejectRatePct : computed.rejectRatePct,
  };
};

/** Create/update body — projectId comes from URL only. */
export const toFabricationApiPayload = (values) => {
  const payload = {
    projectNo: values.projectNo?.trim(),
    client: values.client?.trim(),
    sector: values.sector?.trim() || null,
    promisedMonth: values.promisedMonth || null,
    quotedHours: values.quotedHours,
    actualHours: values.actualHours,
    site: values.site?.trim() || null,
    promisedDeliveryDate: values.promisedDeliveryDate,
    actualDeliveryDate: values.actualDeliveryDate || null,
    totalWeldedJoints: values.totalWeldedJoints ?? 0,
    totalJointsRejected: values.totalJointsRejected ?? 0,
    onTimeFlag:
      values.onTimeFlag != null && values.onTimeFlag !== ''
        ? Number(values.onTimeFlag)
        : null,
  };
  return payload;
};

export const fabricationApiBasePath = (projectId) => `/project/${projectId}/fabrication-dashboard`;
